var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-entity-dialog',{ref:"base",attrs:{"collection":"prescriptions","title":_vm.$t('common.share_prescription'),"shared-toast":_vm.$t('common.prescription_shared')}})
}
var staticRenderFns = []

export { render, staticRenderFns }